export default __webpack_public_path__ + "static/media/Homepage_pics-03-1.c3b93836.jpg";